import { querySelectorURL } from "../../../cpcoc/querySelectorURL";
import { worshipTimes } from "../../data/worship-times";
import { createSlide } from "../../slidesOps/createSlide";
import "./index.scss";
export function slideWorshipTimes() {
    const title = "Worship times";
    const group = querySelectorURL("group");
    const delay = 500;
    const livestream = group === "livestream";
    let html = `
        <div class="worship-time grid">
            <div class="col-4-4">
                <h2 class="text-color worship-time__headline">${title}</h2>
                <hr class="text-color worship-time__rule fragment fade-right" data-autoslide="${delay}" data-fragment-index="0" />
            </div>
    `;
    for (let i = 0, l = worshipTimes.length; i < l; i++) {
        const service = worshipTimes[i];
        if (!service.secondary) {
            const index = i + 1;
            html += `
        <div class="col-4-4 grid worship-time__row">
            <div class="col-3-4">
                <p class="worship-time__name text-color fragment fade-right" data-fragment-index="${index}" data-autoslide="${delay}">
                    ${service.title}
                </p>
            </div>
            <div class="col-1-4">
                <p class="worship-time__time text-color fragment fade-left" data-fragment-index="${index}" data-autoslide="${delay}">
                    ${service.time} ${service.period}${livestream ? " " + service.timezone : ""}
                </p>
            </div>
        </div>
    `;
        }
    }
    html += `
        </div>
        <div class="fragment" data-autoslide="30000"></div>
    `;
    createSlide({
        autoslide: 150,
        center: true,
        html: html,
        background: { color: null },
    }, "worshiptimes");
}
